import {
  useState, useEffect, useMemo,
} from 'react';
import { useHistory } from 'react-router-dom';

import {
  NO_PROGRESS, ACTIVE_STATUS, SETUP_PROGRESS, ASSIGN_PROGRESS,
  UPLOAD_PROGRESS, SUBMIT_PROGRESS, FINISHED_PROGRESS,
} from '../constans/constans';
import {
  handleResponseStatus, sendRequest, checkExistingFieldAgent,
} from '../utils/api-request';
import { getStageMonitoringData } from '../utils/helpers';
import { getMapping } from '../utils/runtime-mappings';
import getConfig from '../config';

const { backendApi } = getConfig();

const useStageProgress = (projectData, runtimeFields) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [stageProgress, setStageProgress] = useState(NO_PROGRESS);

  const projectId = projectData?.project_id;

  const handlers = useMemo(() => ({
    [SETUP_PROGRESS]: () => history.push(`/data-upload/${projectId}`),
    [ASSIGN_PROGRESS]: () => history.push(`/project/${projectId}/field-agents`),
    [UPLOAD_PROGRESS]: () => history.push(`/project/${projectId}/monitoring`),
    [SUBMIT_PROGRESS]: () => history.push(`/project/${projectId}/monitoring`),
    [FINISHED_PROGRESS]: () => {},
  }), [projectData]);

  const isDataUploadExist = (stage) => !!stage.data_upload_at;

  const isMobileDataExist = async (currStageId) => {
    let exists = false;
    const { result, statusCode } = await sendRequest(`${backendApi}/api/dashboard/sample-zone/list`, 'GET', {}, true);
    handleResponseStatus(
      statusCode,
      () => {
        if (result && result.length) {
          const sz = result.filter((el) => el.project_id === projectId);
          const hasMobileData = sz.find((el) => el?.stage_id === currStageId && el?.cid);
          if (hasMobileData) exists = true;
        }
      },
      () => setIsError(true),
    );
    return exists;
  };

  const defineStageProgress = async (data, currStageId) => {
    const { status, stages } = data;

    if (status?.toLowerCase() === ACTIVE_STATUS && currStageId >= 0) {
      // Check if stages report was submitted
      if (isDataUploadExist(stages[currStageId])) {
        return FINISHED_PROGRESS;
      }

      // Check if stage report was sent from mobile app
      if (await isMobileDataExist(currStageId)) {
        return SUBMIT_PROGRESS;
      }

      // Check if field agent was assigned
      const isFieldAgentExist = await checkExistingFieldAgent(data, currStageId);
      if (isFieldAgentExist.error) {
        setIsError(true);
        return NO_PROGRESS;
      }
      if (isFieldAgentExist.exist) {
        return UPLOAD_PROGRESS;
      }

      // Check if monitoring zone and sample plots exist for current stage;
      const { targetStageInfo,targetSubZone } = getStageMonitoringData(data, currStageId);
      if(!!data.stagesInfo && +currStageId!==data.stagesInfo.stage && localStorage.getItem(`ofp_mz_pending_${projectId}`) && !targetStageInfo){
        localStorage.removeItem(`ofp_mz_pending_${projectId}`);

      }
      if (targetStageInfo) {
        return ASSIGN_PROGRESS;
      }
      return SETUP_PROGRESS;
    }
    return NO_PROGRESS;
  };

  useEffect(() => {
    if (!projectData || !runtimeFields) return;

    (async () => {
      setIsLoading(true);
      const currentStage = getMapping(runtimeFields.currentStage);
      const progressId = await defineStageProgress(projectData, currentStage);
      setStageProgress(progressId);
      setIsLoading(false);
    })();
  }, [projectData, runtimeFields]);

  return { isLoading, isError, stageProgress, stageProgressHandler: handlers[stageProgress] };
};

export default useStageProgress;
